import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_DIET_CATEGORY_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateDietCategoryDetailsArgs } from '../graphql/transformers'
import { UPDATE_DIET_CATEGORY_DETAILS } from '../redux/action-types'

const useUpdateDietCategoryDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store => store.diets.dietCategory)

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_DIET_CATEGORY_DETAILS_MUTATION,
        { id, data: transformToUpdateDietCategoryDetailsArgs(data) },
        dispatch,
        UPDATE_DIET_CATEGORY_DETAILS,
      ),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateDietCategoryDetailsMutation
